import React, { useEffect, useState, useContext } from "react";
import { themeContext } from "../../App";
import RightSideHeader from "./rightSideHeader";
import { styles } from "./styles";
import logo from "../../img/headerLogo.png";
import nkcvts from "../../img/nkc.png";
import config from "../../config/config";
import logoDlb from "../../img/djb.png";
import ioclfleet from "../../img/LOGOIOCL.png";
import watsoofleet from "../../img/watsoo.png";

const Header = () => {
  const { color } = useContext(themeContext);
  console.log(color);
  // Function to darken a hex color by a specified percentage
  const darkenColor = (hexColor, percent) => {
    debugger;
    // Parse hex color to RGB
    // Remove the hash if it's present
    const hex = hexColor.replace(/^#/, "");

    // Parse the hex values for each color component
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    // Return the RGB values as an object
    // return { r, g, b };

    // Darken the color (adjust the percentage as needed)
    const darkenAmount = 1 - percent / 100;
    const darkenedColor = `#${Math.round(r * darkenAmount).toString(
      16
    )}${Math.round(g * darkenAmount).toString(16)}${Math.round(
      b * darkenAmount
    ).toString(16)}`;
    console.log(darkenedColor);
    return darkenedColor;
  };
  const [img, setIMG] = useState();
  console.log(img, "logoimg");
  const [fileView, setFileView] = useState();
  console.log(fileView, "fileView");

  return (
    <header
      className="header"
      style={{
        // background: 'linear-gradient("90deg", "#fff", "10%", color, "100%")',
        backgroundImage: `linear-gradient(to right, ${darkenColor(
          color,
          90
        )} , ${color})`,
      }}
    >
      <div style={styles.headerSubContainer}>
        <div style={styles.logoContainer}>
          {config.NkcWeb && (
            <img
              // className={window.location.hostname.split(".")[0]=="cdsfms"?styles.leftSideLogo:""}
              style={
                window.location.hostname.split(".")[0] == "cdsfms"
                  ? styles.leftSideLogo
                  : { width: "290px", height: "65px" }
              }
              //   src={
              //     // `${JSON.parse(localStorage.getItem("config")).logoUrl==null?watsoofleet:
              //     // `${JSON.parse(localStorage.getItem("config")).logoUrl}`}`
              //     JSON.parse(localStorage.getItem("dealerLogoUrl"))?JSON.parse(localStorage.getItem("data")): JSON.parse(localStorage.getItem("data")).dealerLogoUrl ?JSON.parse(localStorage.getItem("data")).imgUrl:JSON.parse(localStorage.getItem("config")).logoUrl
              //     // window.location.hostname.split(".")[0] == "localhost"
              //     //   ? `${JSON.parse(localStorage.getItem("config")).logoUrl}`
              //     //   : window.location.hostname.split(".")[0] == "nkcfms"
              //     //   ? `${JSON.parse(localStorage.getItem("config")).logoUrl}`
              //     //   : window.location.hostname.split(".")[0] == "ceigallfms"
              //     //   ? `${JSON.parse(localStorage.getItem("config")).logoUrl}`
              //     //   : window.location.hostname.split(".")[0] == "cdsfms"
              //     //   ? `${JSON.parse(localStorage.getItem("config")).logoUrl}`
              //     //   : window.location.hostname.split(".")[0] === "192"
              //     //   ? `${JSON.parse(localStorage.getItem("config")).logoUrl}`
              //     //   : watsoofleet
              //   }
              //   alt="header_icon"

              // />

              src={
                JSON.parse(localStorage.getItem("dealerLogoUrl"))
                  ? JSON.parse(localStorage.getItem("dealerLogoUrl"))
                  : JSON.parse(localStorage.getItem("data")).userLogoUrl
                  ? JSON.parse(localStorage.getItem("data")).userLogoUrl
                  : JSON.parse(localStorage.getItem("data")).parentLogoUrl
                  ? JSON.parse(localStorage.getItem("data")).parentLogoUrl
                  : JSON.parse(localStorage.getItem("config")).logoUrl
              }
              alt="header_icon"
            />
          )}

          {/* {
            config.NkcWeb && 
            <img src={window.location.hostname.split(".")[0]=='ioclfleet'?ioclfleet:window.location.hostname.split(".")[0]=='nkcfms'?JSON.parse(localStorage.getItem("config")).logo:watsoofleet} alt='header_icon' />

          } */}
          {config.VTSWeb && <img src={logo} alt="header_icon" />}
          {config.BJBWeb && <img src={logoDlb} alt="header_icon" />}
        </div>
        <RightSideHeader
          img={img}
          setIMG={setIMG}
          setFileView={setFileView}
          fileView={fileView}
        />
      </div>
    </header>
  );
};

export default Header;
